/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Rolespermissionstabledescription4Inputs */

const en_usermanagement_help_rolespermissionstabledescription4 = /** @type {(inputs: Usermanagement_Help_Rolespermissionstabledescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a comprehensive overview of all permissions for each user role`)
};

/**
* | output |
* | --- |
* | "Get a comprehensive overview of all permissions for each user role" |
*
* @param {Usermanagement_Help_Rolespermissionstabledescription4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_rolespermissionstabledescription4 = /** @type {((inputs?: Usermanagement_Help_Rolespermissionstabledescription4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Rolespermissionstabledescription4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_rolespermissionstabledescription4(inputs)
});
export { usermanagement_help_rolespermissionstabledescription4 as "userManagement_help_rolesPermissionsTableDescription" }